<template>
  <div class="page-content">
    <ModalDownload
      v-if="modalClick"
      ref="downloadModal"
      @CloseModal="modalClick = !modalClick"
    />
    <!-- <Blacklist v-show="blockModal" :info="info" @CloseModal="blockModal = !blockModal" /> -->
    <div class="box">
      <div class="box-header">
        <custom :total="totals" />
      </div>
      <table class="table">
        <thead>
          <tr>
            <th class="is-xs">No</th>
            <th class="is-xs">Logo</th>
            <th>Company Name</th>
            <th class="is-lg">Email</th>
            <th class="text-center">CV Points</th>
            <th class="is-sm">Job Points</th>
            <th class="is-xs">Options</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(i, index) in employers" :key="index">
            <td>{{ index + 1 }}</td>
            <td>
              <div class="logo">
                <img :src="$urlImageShow + i.logo" alt="" />
              </div>
            </td>
            <td>{{ i.companyName }}</td>
            <td>{{ i.email }}</td>

            <td class="text-center">
              <span class="icon-group">
                <span class="label">{{ i.cvPoints }}</span>
                <span
                  class="primary"
                  @click="
                    () => {
                      i.addCVPointModal = true;
                    }
                  "
                  ><i class="fa-duotone fa-circle-plus"></i>
                </span>
                <span
                  class="alert"
                  @click="(i.removeCVPointModal = true), (type = 'delete')"
                >
                  <i class="fa-solid fa-xmark"></i>
                </span>
                <div class="add-point" v-if="i.addCVPointModal">
                  <input
                    type="text"
                    v-model="point"
                    class="input"
                    placeholder="0"
                  />
                  <div class="button-group">
                    <button
                      class="button primary small"
                      @click="
                        Cv(i.empId);
                        i.addCVPointModal = false;
                      "
                    >
                      Add
                    </button>
                    <button
                      class="button light-grey small"
                      @click="i.addCVPointModal = false"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
                <div class="add-point" v-if="i.removeCVPointModal">
                  <input
                    type="text"
                    v-model="point"
                    class="input"
                    placeholder="0"
                  />
                  <button
                    class="button primary small"
                    @click="Cv(i.empId), (i.removeCVPointModal = false)"
                  >
                    Deduct
                  </button>
                </div>
              </span>
            </td>
            <td class="text-center">{{ i.point | points }}</td>
            <td class="text-center">
              <span class="icon-group">
                <span
                  @click="
                    $router.push({
                      name: 'company-information',
                      params: { UserId: i.userId },
                    })
                  "
                  ><i class="fad fa-cog"></i
                ></span>
                <span
                  @click="openmodal(i.empId), (modalClick = true)"
                  v-if="!isYellow"
                  ><i class="fad fa-download"></i
                ></span>
                <button
                  :class="[
                    'button primary',
                    { 'is-loading': loading && index === isIndex },
                  ]"
                  @click="Approve(i.empId, index)"
                  v-if="isYellow && permission === 'finance'"
                >
                  ອະນຸມັດ
                </button>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import custom from "../Pagination/customPagination";
// import moment from "moment";
import {
  GET_EMPLOYER,
  ADD_CVPOINT,
  Approved,
} from "../../graphql/employer/employer";
import { apolloClient } from "../../services/apollo-client";
import ModalDownload from "@coms/modal/download.vue";
// import Blacklist from "@coms/modal/blacklist.vue";
export default {
  components: { custom, ModalDownload },
  data: () => ({
    totals: null,
    isLoading: false,
    employers: [],
    addCVPointModal: false,
    removeCVPointModal: false,
    point: "",
    type: "",
    modalClick: false,
    isYellow: false,
    permission: "",
    loading: false,
    isIndex: null,
  }),
  filters: {
    points: function (number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  created() {
    this.queryEmployers();
  },
  watch: {
    "$route.query": {
      handler(val) {
        if (val) {
          this.queryEmployers();
        }
      },
      immediate: true,
      deep: true,
    },
    "$store.getters.isAuthInfo": {
      handler() {
        if (
          this.$store.getters.isAuthInfo &&
          this.$store.getters.isAuthInfo !== null
        ) {
          this.permission = this.$store.getters.isAuthInfo;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async Cv(empId) {
      // save banner
      const isConfirmed = await this.$dialog.confirm();
      if (!isConfirmed) return;
      await apolloClient.mutate({
        mutation: ADD_CVPOINT,
        variables: {
          employerId: empId,
          point: parseInt(this.point),
          type: this.type,
        },
      });
      this.type = "";
      this.point = "";
      this.queryEmployers();
    },
    async queryEmployers() {
      this.isYellow = false;
      if (this.$route.query.type === "Yellowlist") {
        this.isYellow = true;
      }
      const res = await apolloClient.query({
        query: GET_EMPLOYER,
        variables: {
          type: this.$route.query.type,
          page: parseInt(this.$route.query.q),
          perPage: parseInt(this.$route.query.p),
          search: this.$route.query.s,
        },
      });
      this.employers = res.data.getEmployer.employers.map((i) => {
        return {
          ...i,
          addCVPointModal: false,
          removeCVPointModal: false,
        };
      });

      this.totals = res.data.getEmployer.totals;
    },
    async openmodal(id) {
      this.modalClick = true;

      this.$nextTick(() => {
        this.$refs.downloadModal.id = id;
      }, 1000);
    },
    async Approve(id, index) {
      if (!id) return;
      this.loading = true;
      this.isIndex = index;
      await apolloClient
        .mutate({
          mutation: Approved,
          variables: { _id: id },
        })
        .then((res) => {
          if (res) {
            setTimeout(() => {
              this.loading = false;
              this.queryEmployers();
            }, 1000);
          }
        })
        .catch((e) => {
          if (e) {
            this.loading = false;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-group {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  span {
    &.label {
      width: auto !important;
      margin-bottom: 0;
      font-weight: 500;
      border: 1px solid var(--border-color);
      background-color: var(--light-grey-color);
      color: var(--text-color);
      padding: 0 15px;
      &:hover {
        background-color: unset;
      }
    }
  }

  .add-point {
    display: flex;
    border: 1px solid var(--border-color);
    position: absolute;
    z-index: 999;
    left: 0;
    background-color: var(--light-grey-color) !important;
    border-radius: 6px;
    padding: 10px;
    input {
      width: 100px;
      height: 2rem;
    }

    .button-group {
      margin: 0 0 0 10px;
      flex-grow: 1;
      display: flex;
      align-items: center;
      gap: 5px;
      button {
        height: 100%;
        margin: 0;
        font-size: var(--xsm-font);
      }
    }

    * {
      font-size: var(--md-font);
    }
  }
}

.logo {
  max-height: 40px;
  max-width: 40px;
  width: auto;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-height: 40px;
    max-width: 40px;
  }
}
</style>
